/**
 * The client-side route permission rule. The global guard (src/router/index.js) is its only
 * caller; the API remains the real boundary.
 */

/** The one meta key a route declares its permissions under. */
export const ROUTE_PERMISSIONS_KEY = 'permissions';

/**
 * Whether a user who passes `has(list)` may open the route. Each page declares the permissions
 * its own menu entry checks, and only the page's own meta is read: vue-router 3 does not merge a
 * parent's meta into `to.meta`, so parent routes declare none (a test enforces this).
 */
export function isRoutePermitted(route, has) {
  const required = route.meta && route.meta[ROUTE_PERMISSIONS_KEY];
  return required == null || has(required);
}
